import React from "react";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import Spinner from "../../components/layout/Spinner";
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
  SIDEBAR_OPTIONS,
} from "../../shared/enums/skinconcerns_enum";
import SingleView from "../../components/common/SingleView";
import { useSingleSkinconcern } from "../../shared/hooks/UseSkinconcern";

const ViewSkinconcern = ({ match }) => {
  const [data] = useSingleSkinconcern(match.params.id);
  const { skinconcern_loading, skinconcern } = data;
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="View"
        />
        {!skinconcern_loading ? (
          skinconcern && (
            <SingleView
              data={skinconcern}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={skinconcern._id}
              SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewSkinconcern;
